import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden" aria-label="网站主视觉">
      {/* 背景图片 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20digital%20art%20collage%20background%20featuring%20dynamic%20action%20scenes%20and%20romantic%20moments%20from%20various%20comics%2C%20dark%20atmospheric%20tones%20with%20vibrant%20neon%20accent%20highlights%20of%20warm%20coral%20and%20rose%20pink%2C%20speed%20lines%20and%20manga%20screen%20tone%20patterns%20subtly%20integrated%2C%20cinematic%20composition%20with%20deep%20shadows%2C%20professional%20illustration%20quality%2C%20rich%20textures%20and%20dramatic%20lighting%2C%20horizontal%20panoramic%20format&width=1920&height=1080&seq=hero-bg-2026-km&orientation=landscape"
          alt="韩国漫画网 - 免费韩漫在线阅读平台"
          title="韩国漫画网主视觉背景"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* 暗色渐变蒙版 */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>

      {/* 网点纹理叠加 */}
      <div className="absolute inset-0 comic-dot-pattern opacity-30"></div>

      {/* 内容 */}
      <div className="relative z-10 w-full text-center px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <p className="text-comic-accent text-sm md:text-base font-medium tracking-widest mb-4 animate-fade-in">
            KOREAN MANHWA PLATFORM
          </p>
          <h1 className="text-4xl md:text-7xl lg:text-8xl font-black text-white leading-tight mb-6 tracking-tight animate-slide-up">
            <span className="block">免费韩漫</span>
            <span className="block bg-gradient-to-r from-comic-primary via-comic-accent to-comic-cyan bg-clip-text text-transparent">
              随时随地 · 畅享阅读
            </span>
          </h1>
          <p className="text-gray-300 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in">
            海量高清韩漫免费在线看，每日更新最新热门作品，校园恋爱、奇幻冒险、热血动作、悬疑惊悚全品类覆盖
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up">
            <Link
              to="/category/fantasy"
              className="px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line mr-2"></i>
              探索热门
            </Link>
            <Link
              to="/category/school-romance"
              className="px-8 py-3.5 rounded-full bg-comic-primary text-white font-semibold text-sm hover:bg-comic-primary-hover transition-all duration-300 whitespace-nowrap cursor-pointer animate-pulse-glow"
            >
              <i className="ri-book-open-line mr-2"></i>
              立即阅读
            </Link>
          </div>
        </div>
      </div>

      {/* 向下滚动提示 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-scroll-hint">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}